import { DEFAULT_SIZING, billingFor } from './sizing.js';
// Estimado interno → cotización al cliente (Etapa 1d).
//  - El consultor estima horas; no ve la cotización.
//  - Riesgo % sobre las horas del consultor → subtotal (redondeado hacia arriba a 0.5 h).
//  - Gestión % sobre el subtotal → renglón "Gestión del servicio" (el cliente lo ve).
//  - El margen solo afecta el precio, nunca las horas.
//  - La clasificación (≤ 40 h contrato, > 40 h facturación adicional, > 180 h proyecto) se mide
//    contra el SUBTOTAL con riesgo y sin gestión (DECISION_FLUJO_REQ §4.1). La gestión nunca la cambia.
//  - Lo que consume el contrato es el total cotizado (subtotal + gestión).
export const QUOTE_VALID_DAYS = 30;
export const DEFAULT_QUOTE_FACTORS = { riskPct: 10, mgmtPct: 10, marginPct: 0 };
const ceilHalf = (n) => Math.ceil(n * 2 - 1e-9) / 2;
const round2 = (n) => Math.round(n * 100) / 100;
export function calcQuote(estimateHours, f, rate, sizing = DEFAULT_SIZING) {
    const subtotalHours = ceilHalf(estimateHours * (1 + f.riskPct / 100));
    const mgmtHours = ceilHalf(subtotalHours * f.mgmtPct / 100);
    const hours = subtotalHours + mgmtHours;
    const billing = billingFor(subtotalHours, sizing);
    const base = { billing, projectSized: subtotalHours > sizing.reqMaxHours, subtotalHours, mgmtHours, hours };
    if (billing !== 'additional' || rate === null)
        return { ...base, unitPrice: null, price: null };
    const unitPrice = round2(rate * (1 + f.marginPct / 100));
    return { ...base, unitPrice, price: round2(hours * unitPrice) };
}
export function quoteValidUntil(sentAt, days = QUOTE_VALID_DAYS) {
    return new Date(sentAt.getTime() + days * 86_400_000);
}
export const isQuoteExpired = (validUntil, now = new Date()) => now.getTime() > validUntil.getTime();
//# sourceMappingURL=quote.js.map